export default __webpack_public_path__ + "locales/sr-Cyrl-RS/People.json?hash=3d8613148f8e132026d31dd53f2f0da5";